import React from "react";
import "./App.css";

function App() {
  const scrollToServicos = () => {
    const section = document.getElementById("servicos");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>

      {/* NAVBAR */}
      <header className="navbar">
        <div className="nav-container">
          <div className="logo-area">
            <img src="/logo.png" alt="logo" className="logo" />
            <span className="brand">Alphasys</span>
          </div>

          <ul className="menu">
            <li><a href="#inicio">Início</a></li>
            <li><a href="#servicos">Serviços</a></li>
          </ul>
        </div>
      </header>

      {/* HERO */}
      <section id="inicio" className="hero">
        <div className="hero-content">
          <h1>Alphasys Tecnologia</h1>
          <p>Precisa de soluções tecnológicas</p>
          <p>Gestão empresarial completa para sua empresa</p>

          <button onClick={scrollToServicos}>
            Saiba Mais
          </button>
        </div>
      </section>

      {/* SERVIÇOS */}
      <section id="servicos" className="services">
        <div className="services-container">

          <div className="service-card">
            <div className="icon">🌐</div>
            <h3>Sistema Web</h3>
            <p>Aplicações acessadas diretamente pelo navegador.</p>
          </div>

          <div className="service-card">
            <div className="icon">💻</div>
            <h3>Sistema Desktop</h3>
            <p>Software instalado diretamente no computador.</p>
          </div>

          <div className="service-card">
            <div className="icon">📱</div>
            <h3>Sistema Mobile</h3>
            <p>Aplicativos para celulares com acesso rápido.</p>
          </div>

        </div>
      </section>

    </div>
  );
}

export default App;